// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"19":"9049e39c","79":"80917f6d","200":"eb20c67e","539":"f3f8007a","614":"f97eb718","660":"83276d40","682":"98dc0547","884":"9bf92ecb"}[chunkId] + ".js";
};